/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import DadosNota from "./dadosNota";
import FormItensNfe from "./../form-itens-nfe";
import FormVolumesNfe from "./../form-volume-nfe";
import FormTransporteNfe from "./../form-transporte-nfe";
import FormParcelaNfe from "./../form-parcela-nfe";
import FormMensagemNfe from "./../form-mensagem-nfe";
import PdfNfe from "./../pdf-nfe";
import Swal from "sweetalert2";
import api from "../../../services/api";
import consultaApi from "../../../services/consultaApi";
import ListagemNfeProduto from "../listagem-nfe-produto";
import ListagemVolumeNfe from "../listagem-nfe-volume";
import ListagemParcelaNfe from "../listagem-nfe-parcela";
import ListagemMensagemNfe from "../listagem-nfe-mensagem";
import apresentarDecimal from "../../../tools/apresentarDecimal";
import apresentarData from "../../../tools/apresentarData";
import { useHistory } from "react-router-dom";
import dbToBoolean from "../../../tools/dbToBoolean";
import somenteDecimal from "../../../tools/somenteDecimal";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import paraMoedaReal from "../../../tools/paraMoedaReal";
import Paper from "@material-ui/core/Paper";
import ArrowLeftRoundedIcon from "@material-ui/icons/ArrowLeftRounded";
import ArrowRightRoundedIcon from "@material-ui/icons/ArrowRightRounded";
import IconButton from "@material-ui/core/IconButton";
import arredondaDecimal from "../../../tools/arredondaDecimal";
import { Backdrop, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  ocultaCampo: {
    display: "none",
  },
  valorTotal: {
    margin: "5px 5px 0px 0px",
    color: "#01002b",
  },
  paddingEmissao: {
    padding: theme.spacing(1),
  },
  paperTotais: {
    padding: theme.spacing(1),
  },
  totaisTitulo: {
    fontSize: 25,
  },
  totaisLabel: {
    fontSize: 20,
    color: "#002d4e",
  },
  totaisValores: {
    fontSize: 20,
    color: "#002d4e",
  },
  controlaDica: {
    fontSize: 13,
    color: "#a20000",
  },
  controlaAddParcela: {
    margin: "0px 0px 5px 0px",
  },
  controlaParcelas: {
    lineHeight: "44px",
  },
  paperParcelas: {
    padding: 5,
  },
  controlaStepper: {
    padding: "10px 5px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function getSteps() {
  let descricaoEtapas = [
    "Dados Nota Fiscal",
    "Produtos Nota Fiscal",
    "Dados Transporte",
    "Volumes",
    "Parcelas",
    "Menssagens",
    "Emissão",
  ];

  if (!dbToBoolean(localStorage.getItem("APRESENTA_VOLUME"))) {
    descricaoEtapas.splice(
      descricaoEtapas.findIndex((item) => item == "Volumes"),
      1
    );
  }

  if (!dbToBoolean(localStorage.getItem("APRESENTA_PARCELA"))) {
    descricaoEtapas.splice(
      descricaoEtapas.findIndex((item) => item == "Parcelas"),
      1
    );
  }

  if (!dbToBoolean(localStorage.getItem("APRESENTA_TRANSPORTE"))) {
    descricaoEtapas.splice(
      descricaoEtapas.findIndex((item) => item == "Dados Transporte"),
      1
    );
  }

  if (!dbToBoolean(localStorage.getItem("APRESENTA_MENSAGEM"))) {
    descricaoEtapas.splice(
      descricaoEtapas.findIndex((item) => item == "Menssagens"),
      1
    );
  }

  return descricaoEtapas;
}

export default function FormNfe(props) {
  const classes = useStyles();

  const { nfeDados, pessoaToNfe = {} } = props;

  const [codigoNfe, setCodigoNfe] = useState(
    nfeDados.CNRNF ? nfeDados.CNRNF : 0
  );
  const [formulario] = useState(0);
  const [serie] = useState(1);
  const [consumidorFinal] = useState(1);
  const [modeloNota] = useState(55);

  const [cliente, setCliente] = useState(
    pessoaToNfe.CCDPESS
      ? pessoaToNfe.CCDPESS
      : nfeDados.CCDPESS
      ? nfeDados.CCDPESS
      : ""
  );
  const [descricaoCliente, setDescricaoCliente] = useState(
    pessoaToNfe.CDSPESS
      ? pessoaToNfe.CDSPESS
      : nfeDados.CDSPESS
      ? nfeDados.CDSPESS
      : ""
  );
  const [clienteErro, setClienteErro] = useState(false);
  const [clienteErroTexto, setClienteErroTexto] = useState("");

  const [cfop, setCfop] = useState(
    nfeDados.CCDCFOP ? nfeDados.CCDCFOP : localStorage.getItem("CFOP_PADRAO")
  );
  const [descricaoCfop, setDescricaoCfop] = useState(
    nfeDados.CDSCFOP
      ? nfeDados.CDSCFOP
      : localStorage.getItem("DESCRICAO_CFOP_PADRAO")
  );
  const [cfopErro, setCfopErro] = useState(false);
  const [cfopErroTexto, setCfopErroTexto] = useState("");

  const [modeloEntrega, setModeloEntrega] = useState(
    nfeDados.NPRESENCIAL ? nfeDados.NPRESENCIAL : 1
  );
  const [modeloEntregaErro] = useState(false);
  const [modeloEntregaErroTexto] = useState("");

  const [tipoFrete, setTipoFrete] = useState(
    nfeDados.CCIFFOB ? nfeDados.CCIFFOB : "C"
  );
  const [tipoFreteErro] = useState(false);
  const [tipoFreteErroTexto] = useState("");

  const [transportadora, setTransportadora] = useState(
    nfeDados.CCDTRANS ? nfeDados.CCDTRANS : ""
  );
  const [descricaoTransportadora, setDescricaoTransportadora] = useState(
    nfeDados.CDSTRANSP ? nfeDados.CDSTRANSP : ""
  );
  const [transportadoraErro, setTransportadoraErro] = useState(false);
  const [transportadoraErroTexto, setTransportadoraErroTexto] = useState("");

  const [veiculo, setVeiculo] = useState(
    nfeDados.CPLACA ? nfeDados.CPLACA : ""
  );
  const [veiculoErro] = useState(false);
  const [veiculoErroTexto] = useState("");

  const [autorizada, setAutorizada] = useState(
    nfeDados.LAUTORIZADA ? dbToBoolean(nfeDados.LAUTORIZADA) : false
  );
  const [cancelada, setCancelada] = useState(
    nfeDados.LCANCELADA ? dbToBoolean(nfeDados.LCANCELADA) : false
  );

  const [itensNota, setItensNota] = useState([]);
  const [volumesNota, setVolumesNota] = useState([]);
  const [parcelasNota, setParcelasNota] = useState([]);
  const [mensagensNota, setMensagensNota] = useState([]);

  const [valorTotalPreco, setValorTotalPreco] = useState(0);
  const [valorTotalNfe, setValorTotalNfe] = useState(
    nfeDados.NVLTOTAL ? nfeDados.NVLTOTAL : 0
  );
  const [valorTotalParcelas, setValorTotalParcelas] = useState(0);
  const [valorTotalDesconto, setValorTotalDesconto] = useState(0);
  const [valorTotalFrete, setValorTotalFrete] = useState(0);
  const [valorTotalSeguro, setValorTotalSeguro] = useState(0);
  const [valorTotalOutros, setValorTotalOutros] = useState(0);

  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);

  const [loading, setLoading] = useState(false);

  const [activeStep, setActiveStep] = useState(
    nfeDados.CNRNF ? getSteps().findIndex((item) => item == "Emissão") : 0
  );
  const steps = getSteps();

  const history = useHistory();

  useEffect(() => {
    async function carregarItems() {
      let itens = [];

      let dadosEnvio = {
        PROCNAME: "WEBSITE_LISTAGEM_NFEI",
        PCNRNF: codigoNfe,
      };

      const resposta = await consultaApi(dadosEnvio);

      if (resposta.data.CODIGO_ERRO == 0 && resposta.data.DATASET) {
        resposta.data.DATASET.map((item) => {
          return itens.push({
            codigoItem: item.CNRNFI,
            produto: item.CCDPMS,
            descricaoProduto: item.CDSPMS,
            descricaoDetalhada: item.CDETPMS,
            quantidade: item.NQTPROD,
            preco: apresentarDecimal(item.NPRPROD),
            desconto: apresentarDecimal(item.NVLDESCON),
            grupoImposto: item.CCDTAXGRUPO,
            descricaoGrupoImposto: item.CDSTAXGRUPO,
            cfop: item.CCDCFOP,
            descricaoCfop: item.CDSCFOP,
            frete: apresentarDecimal(item.NVLFRETE),
            seguro: apresentarDecimal(item.NVLSEGURO),
            outros: apresentarDecimal(item.NVLOUTROS),
          });
        });
      }

      setItensNota(itens);
    }

    async function carregarVolumes() {
      let volumes = [];

      let dadosEnvio = {
        PROCNAME: "WEBSITE_LISTAGEM_NFVOLUMES",
        PCNRNF: codigoNfe,
      };

      const respostaVolumes = await consultaApi(dadosEnvio);

      if (
        respostaVolumes.data.CODIGO_ERRO == 0 &&
        respostaVolumes.data.DATASET
      ) {
        respostaVolumes.data.DATASET.map((volume) => {
          return volumes.push({
            codigoVolume: volume.CNRVOL,
            quantidade: volume.NQTVOL,
            pesoBruto: volume.NKGBRUTO,
            pesoLiquido: volume.NKGLIQ,
            numeracao: volume.CNUMERACAO,
            especie: volume.CESPECIE,
            marca: volume.CMARCA,
          });
        });
      }

      setVolumesNota(volumes);
    }

    async function carregarParcelas() {
      let parcelas = [];

      let dadosEnvio = {
        PROCNAME: "WEBSITE_LISTAGEM_NFEPARCELA",
        PCNRNF: codigoNfe,
      };

      const respostaParcelas = await consultaApi(dadosEnvio);

      if (
        respostaParcelas.data.CODIGO_ERRO == 0 &&
        respostaParcelas.data.DATASET
      ) {
        respostaParcelas.data.DATASET.map((parcela) => {
          return parcelas.push({
            codigoParcela: parcela.CNRNFI,
            tipoDocumento: parcela.CCDTYDOCF,
            valor: apresentarDecimal(parcela.NVLVENCI),
            vencimento: apresentarData(parcela.DDTVENCI),
          });
        });
      }

      setParcelasNota(parcelas);
    }

    async function carregarMensagens() {
      let mensagens = [];

      let dadosEnvio = {
        PROCNAME: "WEBSITE_LISTAGEM_NFMSG",
        PCNRNF: codigoNfe,
      };

      const respostaMensagem = await consultaApi(dadosEnvio);

      if (
        respostaMensagem.data.CODIGO_ERRO == 0 &&
        respostaMensagem.data.DATASET
      ) {
        respostaMensagem.data.DATASET.map((mensagem) => {
          return mensagens.push({
            codigoMensagem: mensagem.CNRNFI,
            tipoMensagem: mensagem.NPOS,
            texto: mensagem.CTEXTO,
          });
        });
      }

      setMensagensNota(mensagens);
    }
    if (codigoNfe != 0) {
      carregarItems();
      carregarVolumes();
      carregarParcelas();
      carregarMensagens();
    }
  }, []);

  useEffect(() => {
    let totalDesconto = 0;
    let totalFrete = 0;
    let totalOutros = 0;
    let totalPreco = 0;
    let totalSeguro = 0;
    // eslint-disable-next-line array-callback-return
    itensNota.map((item) => {
      item.desconto
        ? (totalDesconto += Number(somenteDecimal(item.desconto)))
        : (item.desconto = 0);
      item.frete
        ? (totalFrete += Number(somenteDecimal(item.frete)))
        : (item.frete = 0);
      item.outros
        ? (totalOutros += Number(somenteDecimal(item.outros)))
        : (item.outros = 0);
      item.quantidade
        ? (totalPreco +=
            Number(somenteDecimal(item.preco)) *
            Number(somenteDecimal(item.quantidade)))
        : (item.preco = 0);
      item.seguro
        ? (totalSeguro += Number(somenteDecimal(item.seguro)))
        : (item.seguro = 0);
    });
    setValorTotalDesconto(totalDesconto);
    setValorTotalFrete(totalFrete);
    setValorTotalOutros(totalOutros);
    setValorTotalPreco(arredondaDecimal(totalPreco, 8));
    setValorTotalSeguro(totalSeguro);
    setValorTotalNfe(
      arredondaDecimal(
        totalFrete + totalOutros + totalPreco + totalSeguro - totalDesconto,
        8
      )
    );
  }, [itensNota]);

  useEffect(() => {
    let totalParcelas = 0;
    // eslint-disable-next-line array-callback-return
    parcelasNota.map((parcela) => {
      if (parcela.valor === undefined && autorizada) {
        totalParcelas += 0;
      } else {
        totalParcelas += Number(somenteDecimal(parcela.valor));
      }
    });
    setValorTotalParcelas(totalParcelas);
  }, [parcelasNota]);

  function getStepContent(step) {
    // eslint-disable-next-line default-case
    switch (getSteps()[step]) {
      case "Dados Nota Fiscal":
        return (
          <>
            <DadosNota
              cliente={cliente}
              clienteErro={clienteErro}
              clienteErroTexto={clienteErroTexto}
              setCliente={setCliente}
              descricaoCliente={descricaoCliente}
              setDescricaoCliente={setDescricaoCliente}
              cfop={cfop}
              cfopErro={cfopErro}
              cfopErroTexto={cfopErroTexto}
              setCfop={setCfop}
              descricaoCfop={descricaoCfop}
              setDescricaoCfop={setDescricaoCfop}
              inativo={autorizada}
            />
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress />
            </Backdrop>
          </>
        );
      case "Produtos Nota Fiscal":
        return (
          <>
            <FormItensNfe
              adicionarItem={adicionarItem}
              inativo={autorizada}
              cfopPai={cfop}
              descricaoCfopPai={descricaoCfop}
            />

            <ListagemNfeProduto
              adicionarItem={adicionarItem}
              removerItem={removerItem}
              autorizada={autorizada}
              itensNota={itensNota}
              inativo={autorizada}
              cfopPai={cfop}
              descricaoCfopPai={descricaoCfop}
            />

            <Divider />

            <Grid container>
              <Grid item xs={12}>
                {valorTotalNfe != 0 && (
                  <Typography
                    variant="h5"
                    component="h5"
                    className={classes.valorTotal}
                    gutterBottom
                    align="right"
                  >
                    Total Itens: {paraMoedaReal(valorTotalNfe, 2)}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Divider />
          </>
        );
      case "Dados Transporte":
        return (
          <>
            <FormTransporteNfe
              modeloEntrega={modeloEntrega}
              modeloEntregaErro={modeloEntregaErro}
              modeloEntregaErroTexto={modeloEntregaErroTexto}
              setModeloEntrega={setModeloEntrega}
              tipoFrete={tipoFrete}
              tipoFreteErro={tipoFreteErro}
              tipoFreteErroTexto={tipoFreteErroTexto}
              setTipoFrete={setTipoFrete}
              transportadora={transportadora}
              transportadoraErro={transportadoraErro}
              transportadoraErroTexto={transportadoraErroTexto}
              setTransportadora={setTransportadora}
              veiculo={veiculo}
              veiculoErro={veiculoErro}
              veiculoErroTexto={veiculoErroTexto}
              setVeiculo={setVeiculo}
              descricaoTransportadora={descricaoTransportadora}
              setDescricaoTransportadora={setDescricaoTransportadora}
              inativo={autorizada}
            />
          </>
        );
      case "Volumes":
        return (
          <>
            <FormVolumesNfe
              adicionarVolume={adicionarVolume}
              inativo={autorizada}
            />
            <ListagemVolumeNfe
              adicionarVolume={adicionarVolume}
              removerVolume={removerVolume}
              volumesNota={volumesNota}
              inativo={autorizada}
            />
          </>
        );
      case "Parcelas":
        return (
          <>
            {!autorizada && (
              <Typography className={classes.controlaDica}>
                *As parcelas devem totalizar {paraMoedaReal(valorTotalNfe, 2)}
              </Typography>
            )}

            <Paper variant="outlined" className={classes.paperParcelas}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.controlaParcelas}>
                    Parcelar em:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={4}>
                      <IconButton
                        aria-label="diminuir"
                        disabled={
                          quantidadeParcelas <= 1 || autorizada ? true : false
                        }
                        onClick={() =>
                          setQuantidadeParcelas(quantidadeParcelas - 1)
                        }
                      >
                        <ArrowLeftRoundedIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={4} align="center">
                      <Typography className={classes.controlaParcelas}>
                        {quantidadeParcelas}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <IconButton
                        aria-label="aumentar"
                        disabled={autorizada}
                        onClick={() =>
                          setQuantidadeParcelas(quantidadeParcelas + 1)
                        }
                      >
                        <ArrowRightRoundedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>

            <FormParcelaNfe
              totalNfe={valorTotalNfe}
              quantidadeParcelas={quantidadeParcelas}
              adicionarParcela={adicionarParcela}
              inativo={autorizada}
            />
            <ListagemParcelaNfe
              adicionarParcela={adicionarParcela}
              removerParcela={removerParcela}
              parcelasNota={parcelasNota}
              autorizada={autorizada}
              inativo={autorizada}
            />
            <Divider />
            {valorTotalParcelas != 0 && (
              <Typography
                variant="h5"
                component="h5"
                className={classes.valorTotal}
                gutterBottom
                align="right"
              >
                Total Parcelas: {paraMoedaReal(valorTotalParcelas, 2)}
              </Typography>
            )}
            <Divider />
          </>
        );
      case "Menssagens":
        return (
          <>
            <FormMensagemNfe
              adicionarMensagem={adicionarMensagem}
              inativo={autorizada}
            />
            <ListagemMensagemNfe
              adicionarMensagem={adicionarMensagem}
              removerMensagem={removerMensagem}
              mensagensNota={mensagensNota}
              inativo={autorizada}
            />
          </>
        );
      case "Emissão":
        return (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Typography className={classes.controlaDica}>
                  *Clique nos passos anteriores para{" "}
                  {autorizada ? "visualizar" : "editar"}
                </Typography>
                <Paper variant="outlined" className={classes.paperTotais}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography
                        align="center"
                        component="h3"
                        color="secondary"
                        variant="h3"
                        className={classes.totaisTitulo}
                        gutterBottom
                      >
                        Totais
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        align="left"
                        component="h5"
                        variant="h5"
                        className={classes.totaisLabel}
                      >
                        Produtos:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        align="right"
                        component="h5"
                        variant="h5"
                        className={classes.totaisValores}
                      >
                        {paraMoedaReal(valorTotalPreco, 2)}
                      </Typography>
                    </Grid>
                    {valorTotalDesconto > 0 && (
                      <>
                        <Grid item xs={6}>
                          <Typography
                            align="left"
                            component="h5"
                            variant="h5"
                            className={classes.totaisLabel}
                          >
                            Descontos:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            align="right"
                            component="h5"
                            variant="h5"
                            className={classes.totaisValores}
                          >
                            {paraMoedaReal(valorTotalDesconto, 2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {valorTotalFrete > 0 && (
                      <>
                        <Grid item xs={6}>
                          <Typography
                            align="left"
                            component="h5"
                            variant="h5"
                            className={classes.totaisLabel}
                          >
                            Frete:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            align="right"
                            component="h5"
                            variant="h5"
                            className={classes.totaisValores}
                          >
                            {paraMoedaReal(valorTotalFrete, 2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {valorTotalSeguro > 0 && (
                      <>
                        <Grid item xs={6}>
                          <Typography
                            align="left"
                            component="h5"
                            variant="h5"
                            className={classes.totaisLabel}
                          >
                            Seguro:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            align="right"
                            component="h5"
                            variant="h5"
                            className={classes.totaisValores}
                          >
                            {paraMoedaReal(valorTotalSeguro, 2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {valorTotalOutros > 0 && (
                      <>
                        <Grid item xs={6}>
                          <Typography
                            align="left"
                            component="h5"
                            variant="h5"
                            className={classes.totaisLabel}
                          >
                            Outros:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            align="right"
                            component="h5"
                            variant="h5"
                            className={classes.totaisValores}
                          >
                            {paraMoedaReal(valorTotalOutros, 2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        align="left"
                        component="h5"
                        variant="h5"
                        className={classes.totaisValores}
                      >
                        Total:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        align="right"
                        component="h5"
                        variant="h5"
                        className={classes.totaisValores}
                      >
                        {paraMoedaReal(valorTotalNfe, 2)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              {!autorizada && (
                <Grid item xs={6} className={classes.paddingEmissao}>
                  <Button
                    className={autorizada && classes.ocultaCampo}
                    variant="contained"
                    color="secondary"
                    type="submit"
                    fullWidth
                    onClick={emitir}
                  >
                    Emitir
                  </Button>
                </Grid>
              )}

              {apresentarPdf()}

              {autorizada && (
                <>
                  <Grid item xs={6} className={classes.paddingEmissao}>
                    <Button
                      className={
                        autorizada && !cancelada ? "" : classes.ocultaCampo
                      }
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      onClick={enviarEmail}
                    >
                      E-mail
                    </Button>
                  </Grid>
                  <Grid item xs={6} className={classes.paddingEmissao}>
                    <Button
                      className={
                        autorizada && !cancelada ? "" : classes.ocultaCampo
                      }
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      onClick={cancelarNfe}
                    >
                      Cancelar
                    </Button>
                  </Grid>
                </>
              )}

              {!autorizada ? (
                <>
                  <Grid
                    item
                    xs={cancelada ? 12 : 6}
                    className={classes.paddingEmissao}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      fullWidth
                      onClick={comprovante}
                    >
                      Comprovante
                    </Button>
                  </Grid>
                  
                  <Grid
                    item
                    xs={cancelada ? 12 : 6}
                    className={classes.paddingEmissao}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      fullWidth
                      onClick={salvar}
                    >
                      Salvar
                    </Button>
                  </Grid>
                </>  
              ) : (
                <Grid
                  item
                  xs={cancelada ? 12 : 6}
                  className={classes.paddingEmissao}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    onClick={sair}
                  >
                    Sair
                  </Button>
                </Grid>
              )}
            </Grid>
          </>
        );
    }
  }

  const handleNext = async () => {
    if (await validaCampos(activeStep + 1)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setLoading(false);
  };

  function adicionarItem(item, indexItem = -1) {
    if (indexItem < 0) {
      setItensNota((itensNota) => [...itensNota, item]);
    } else {
      let itemTemp = itensNota;
      itemTemp[indexItem] = item;
      setItensNota((itemTemp) => [...itemTemp]);
    }
  }

  //Verificar necessidade das variáveis armazenando splice sem utilizar
  function removerItem(indexItem) {
    // eslint-disable-next-line no-unused-vars
    let itensTemp = itensNota.splice(indexItem, 1);
    setItensNota((itensTemp) => [...itensTemp]);
  }

  function adicionarVolume(volume, indexVolume = -1) {
    if (indexVolume < 0) {
      setVolumesNota((volumesNota) => [...volumesNota, volume]);
    } else {
      let volumeTemp = volumesNota;
      volumeTemp[indexVolume] = volume;
      setVolumesNota((volumeTemp) => [...volumeTemp]);
    }
  }

  function removerVolume(indexVolume) {
    // eslint-disable-next-line no-unused-vars
    let volumeTemp = volumesNota.splice(indexVolume, 1);
    setVolumesNota((volumeTemp) => [...volumeTemp]);
  }

  async function adicionarParcela(parcela, indexParcela = -1) {
    if (indexParcela < 0) {
      if (codigoNfe) {
        let dadosEnvio = {
          PROCNAME: "WEBSITE_NFPARCELA_DELETE_ALL",
          PCNRNF: codigoNfe,
        };

        await consultaApi(dadosEnvio);
      }

      setParcelasNota(parcela);
    } else {
      let parcelaTemp = parcelasNota;
      parcelaTemp[indexParcela] = parcela;
      setParcelasNota((parcelaTemp) => [...parcelaTemp]);
    }
  }

  function removerParcela(indexParcela) {
    // eslint-disable-next-line no-unused-vars
    let parcelasTemp = parcelasNota.splice(indexParcela, 1);
    setParcelasNota((parcelasTemp) => [...parcelasTemp]);
  }

  function adicionarMensagem(mensagem, indexMensagem = -1) {
    if (indexMensagem < 0) {
      setMensagensNota((mensagensNota) => [...mensagensNota, mensagem]);
    } else {
      let mensagemTemp = mensagensNota;
      mensagemTemp[indexMensagem] = mensagem;
      setMensagensNota((mensagemTemp) => [...mensagemTemp]);
    }
  }

  function removerMensagem(indexMensagem) {
    // eslint-disable-next-line no-unused-vars
    let mensagemTemp = mensagensNota.splice(indexMensagem, 1);
    setMensagensNota((mensagemTemp) => [...mensagemTemp]);
  }

  async function CalcularTotais(codigoNfe) {
    let dadosEnvio = {
      PROCNAME: "WEBSITE_NFE_TOTAL",
      PCNRNF: codigoNfe
    };

    const respostaNfe = await consultaApi(dadosEnvio);
    return respostaNfe;
  }

  async function salvarNfe() {
    let dadosEnvio = {
      PROCNAME: "WEBSITE_NFE_ADD",
      PCNRNF: codigoNfe,
      PCNRFORM: formulario,
      PCSERIE: serie,
      PCCDPESS: cliente,
      PCCDCFOP: cfop,
      PLCONSUMIDORFINAL: consumidorFinal,
      PNPRESENCIAL: modeloEntrega,
      PCCDTRANS:
        modeloEntrega === 0 || modeloEntrega === 1 ? 0 : transportadora,
      PCPLACA: veiculo,
      PCCDTPDOCFIS: modeloNota,
      PCCIFFOB: tipoFrete,
    };

    const respostaNfe = await consultaApi(dadosEnvio);
    if (codigoNfe === 0) {
      setCodigoNfe(respostaNfe.data.PCNRNF);
    }

    return respostaNfe;
  }

  async function salvarProdutosNfe(codigoNfe) {
    await Promise.all(
      itensNota.map((item, index) => {
        return new Promise(async (resolve, reject) => {
          try {
            let dadosEnvioItem = {
              PROCNAME: "WEBSITE_NFEI_ADD",
              PCNRNF: codigoNfe,
              PCNRNFI: item.codigoItem,
              PCCDPMS: item.produto,
              PCDETPMS: item.descricaoDetalhada,
              PCCDTAXGRUPO: item.grupoImposto,
              PCCDCFOP: item.cfop,
              PNQTPROD: item.quantidade,
              PNPRPROD: item.preco,
              PNVLDESCON: item.desconto,
              PNVLFRETE: item.frete,
              PNVLSEGURO: item.seguro,
              PNVLOUTROS: item.outros,
            };

            const respostaProdutoNfe = await consultaApi(dadosEnvioItem);
            let itensTemp = itensNota;
            itensTemp[index].codigoItem = respostaProdutoNfe.data.PCNRNFI;
            setItensNota(itensTemp);
            resolve(respostaProdutoNfe);
          } catch (error) {
            reject(error);
          }
        });
      })
    )
      .catch((result) => {
        return { error: result };
      })
      .then((result) => {
        return result;
      });
  }

  async function salvarVolumes(codigoNfe) {
    await Promise.all(
      volumesNota.map((volume, index) => {
        return new Promise(async (resolve, reject) => {
          try {
            let dadosEnvioVolume = {
              PROCNAME: "WEBSITE_NFVOLUMES_ADD",
              PCNRNF: codigoNfe,
              PCNRVOL: volume.codigoVolume,
              PCMARCA: volume.marca,
              PCESPECIE: volume.especie,
              PCNUMERACAO: volume.numeracao,
              PNKGLIQ: volume.pesoLiquido,
              PNKGBRUTO: volume.pesoBruto,
              PNQTVOL: volume.quantidade,
            };

            const resposta = await consultaApi(dadosEnvioVolume);

            let volumesTemp = volumesNota;
            volumesTemp[index].codigoVolume = resposta.data.PCNRVOL;
            setVolumesNota(volumesTemp);
            resolve(resposta);
          } catch (error) {
            reject(error);
          }
        });
      })
    )
      .catch((result) => {
        return { error: result };
      })
      .then((result) => {
        return result;
      });
  }

  async function salvarParcelas(codigoNfe) {
    await Promise.all(
      parcelasNota.map((parcela, index) => {
        return new Promise(async (resolve, reject) => {
          try {
            let dadosEnvioParcela = {
              PROCNAME: "WEBSITE_NPARCELA_ADD",
              PCNRNF: codigoNfe,
              PCNRNFI: parcela.codigoParcela,
              PCCDTYDOCF: parcela.tipoDocumento,
              PNVLVENCI: parcela.valor,
              PDDTVENCI: parcela.vencimento,
            };

            const resposta = await consultaApi(dadosEnvioParcela);
            let parcelasTemp = parcelasNota;
            parcelasTemp[index].codigoParcela = resposta.data.PCNRNFI;
            setParcelasNota(parcelasTemp);
            resolve(resposta);
          } catch (error) {
            reject(error);
          }
        });
      })
    )
      .catch((result) => {
        return { error: result };
      })
      .then((result) => {
        return result;
      });
  }

  async function salvarMensagens(codigoNfe) {
    await Promise.all(
      mensagensNota.map((mensagem, index) => {
        return new Promise(async (resolve, reject) => {
          try {
            let dadosEnvioMensagem = {
              PROCNAME: "WEBSITE_NFMSG_ADD",
              PCNRNF: codigoNfe,
              PCNRNFI: mensagem.codigoMensagem,
              PNPOS: mensagem.tipoMensagem,
              PCTEXTO: mensagem.texto,
            };

            const resposta = await consultaApi(dadosEnvioMensagem);
            let mensagensTemp = mensagensNota;
            mensagensTemp[index].codigoMensagem = resposta.data.PCNRNFI;
            setMensagensNota(mensagensTemp);
            resolve(resposta);
          } catch (error) {
            reject(error);
          }
        });
      })
    )
      .catch((result) => {
        return { error: result };
      })
      .then((result) => {
        return result;
      });
  }

  async function salvar(e) {
    if (e) {
      e.preventDefault();
    }

    let error = false;

    if (validaCampos()) {
      const respostaNfe = await salvarNfe();
      if (respostaNfe.data.CODIGO_ERRO !== 0) {
        return error;
      } else {
        setCodigoNfe(respostaNfe.data.PCNRNF);
      }

      await salvarProdutosNfe(respostaNfe.data.PCNRNF);
      await salvarVolumes(respostaNfe.data.PCNRNF);
      await salvarParcelas(respostaNfe.data.PCNRNF);
      await salvarMensagens(respostaNfe.data.PCNRNF);
      await CalcularTotais(respostaNfe.data.PCNRNF);

      if (e) {
        if (!error) {
          Swal.fire({
            type: "success",
            html: `<h1>Salvo</h1>`,
          });          
          vaiListagem();
        } else {
          Swal.fire({
            type: "error",
          });
        }
      } else {
        return { error, codigoNfe: respostaNfe.data.PCNRNF };
      }      
    }
  }

  function vaiListagem() {
    history.push("/nfe");
  }
  

  async function comprovante(e) {
    if (e) {
      e.preventDefault();
    }  

    let error = false;

    let retornoSalvar = await salvar();

    if (retornoSalvar.codigoNfe == 0) {
      error = true;
    } else {
      let dadosEnvio = {
        DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
        DBUSERNAME: localStorage.getItem("DBUSERNAME"),
        DBESQUEMA: localStorage.getItem("DBESQUEMA"),
        DBPID: localStorage.getItem("DBPID"),
        MANDNUMBER: localStorage.getItem("MANDNUMBER"),
        EMPNUMBER: localStorage.getItem("EMPNUMBER"),
        PARAMNAMES: "COMPROVANTE_NAO_FISCAL",
        PARAMVALUES: retornoSalvar.codigoNfe,
        PCCDTPDOCFIS: '55'
      };
  
      const resposta = await api.post('execute/pdf', dadosEnvio);
  
      const linkSource = `data:application/pdf;base64,${resposta.data.PPDF.replaceAll('\n', '').replaceAll('\r', '')}`;
      const downloadLink = document.createElement("a");
      const fileName = `${resposta.data.PFILENAME}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }

    if (e) {
      if (!error) {
        Swal.fire({
          type: "success",
          html: `<h1>Salvo</h1>`,
        });          
        vaiListagem();
      } else {
        Swal.fire({
          type: "error",
        });
      }
    }    
  }

  async function emitir() {
    Swal.fire({
      type: "question",
      title: "Emitir NF-e ?",
      showCancelButton: true,
      confirmButtonText: "Emitir",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: (result) => {
        return new Promise(async (resolve, reject) => {
          let retornoSalvar = await salvar();
          let dadosEmissao = {
            DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
            DBUSERNAME: localStorage.getItem("DBUSERNAME"),
            DBESQUEMA: localStorage.getItem("DBESQUEMA"),
            DBPID: localStorage.getItem("DBPID"),
            SESSIONNUMBER: "0",
            MANDNUMBER: localStorage.getItem("MANDNUMBER"),
            EMPNUMBER: localStorage.getItem("EMPNUMBER"),
            USERNUMBER: localStorage.getItem("USERNUMBER"),
            SERVICENAME: "NFE",
            PARAMNAMES: "EMITIR_55",
            PARAMVALUES: retornoSalvar.codigoNfe,
            FILENUMBER: "PDF",
          };

          const resposta = await api.post("/execute/docfiscal", dadosEmissao);
          if (resposta.data.erro == 0) {
            setAutorizada(true);
          }
          resolve(resposta.data);
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          type: result.value.erro == 0 ? "success" : "error",
          title: "Resultado",
          text: result.value.msg,
        });
      }
    });
  }

  async function enviarEmail() {
    let dadosEnvioBuscaEmail = {
      PROCNAME: "WEBSITE_BUSCA_EMAIL",
      PCCDPESS: cliente,
    };

    const respostaBuscaEmail = await consultaApi(dadosEnvioBuscaEmail);

    Swal.fire({
      title: "Informe o E-Mail",
      input: "text",
      inputValue: respostaBuscaEmail.data.EMAIL,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async (email) => {
        let dadosEmailNfe = {
          PROCNAME: "WEBSITE_INFO_PROC_NF",
          PCNRNF: codigoNfe,
          PROCESSO: "EMAIL",
          VALOR: email,
        };

        await consultaApi(dadosEmailNfe);

        let dadosEmissao = {
          DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
          DBUSERNAME: localStorage.getItem("DBUSERNAME"),
          DBESQUEMA: localStorage.getItem("DBESQUEMA"),
          DBPID: localStorage.getItem("DBPID"),
          SESSIONNUMBER: "0",
          MANDNUMBER: localStorage.getItem("MANDNUMBER"),
          EMPNUMBER: localStorage.getItem("EMPNUMBER"),
          USERNUMBER: localStorage.getItem("USERNUMBER"),
          SERVICENAME: "NFE",
          PARAMNAMES: "EMAIL_55",
          PARAMVALUES: codigoNfe,
          FILENUMBER: "PDF",
        };

        const resposta = await api.post("/execute/docfiscal", dadosEmissao);

        return resposta.data;
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          type: "success",
          html: `<p>${result.value.msg}</p>`,
        });
      }
    });
  }

  async function cancelarNfe() {
    Swal.fire({
      title: "Motivo Cancelamento (Minimo 15 caracteres)",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: (justificativa) => {
        return new Promise(async (resolve, reject) => {
          let dadosCancelarNfe = {
            PROCNAME: "WEBSITE_INFO_PROC_NF",
            PCNRNF: codigoNfe,
            PROCESSO: "CANCELAR",
            VALOR: justificativa,
          };

          await consultaApi(dadosCancelarNfe);

          let dadosCancelar = {
            DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
            DBUSERNAME: localStorage.getItem("DBUSERNAME"),
            DBESQUEMA: localStorage.getItem("DBESQUEMA"),
            DBPID: localStorage.getItem("DBPID"),
            SESSIONNUMBER: "0",
            MANDNUMBER: localStorage.getItem("MANDNUMBER"),
            EMPNUMBER: localStorage.getItem("EMPNUMBER"),
            USERNUMBER: localStorage.getItem("USERNUMBER"),
            SERVICENAME: "NFE",
            PARAMNAMES: "CANCELAR_55",
            PARAMVALUES: codigoNfe,
            FILENUMBER: "PDF",
          };

          const resposta = await api.post("/execute/docfiscal", dadosCancelar);

          if (resposta.data.erro == 0) {
            setCancelada(true);
          }

          resolve(resposta.data);
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Resultado",
          text: result.value.msg,
        });
      }
    });
  }

  async function validaCampos(step) {
    let camposErrados = [];
    let cfopIncorreto = false;
    let nomeEtapa = getSteps()[activeStep];

    if (nomeEtapa === "Dados Nota Fiscal") {
      if (cliente === "") {
        setClienteErro(true);
        setClienteErroTexto("Por favor preencha o Cliente,campo obrigatorio");
        camposErrados.push("Cliente");
      } else {
        if (descricaoCliente === "") {
          setClienteErro(true);
          setClienteErroTexto("Informe um cliente valido, use a pesquisa");
          camposErrados.push("Clente");
        } else {
          setClienteErro(false);
        }
      }

      if (cfop === "") {
        setCfopErro(true);
        setCfopErroTexto("Por favor preencha o Cfop,campo obrigatorio");
        camposErrados.push("CFOP");
      } else {
        if (descricaoCfop === "") {
          setCfopErro(true);
          setCfopErroTexto("Por favor preencha o Cfop,campo obrigatorio");
          camposErrados.push("CFOP");
        } else {
          setCfopErro(false);
        }
      }

      if (camposErrados.length === 0 && !autorizada) {
        let dadosConsultaCliente = {
          PROCNAME: "WEBSITE_GPESSOA_L_BYID",
          EMPNUMBER: localStorage.getItem("EMPNUMBER"),
          PCCDPESS: cliente,
        };

        setLoading(!autorizada && true);
        const retornoDadosCliente = await consultaApi(dadosConsultaCliente);
        if (retornoDadosCliente.data.DATASET[0].CPESSOA == "E") {
          setLoading(false);
          //IMPLEMENTAR REGRA PESSOA ESTRANGEIRA
        } else {
          if (
            retornoDadosCliente.data.DATASET[0].CCDCIDADE.toString().substring(
              0,
              2
            ) == localStorage.getItem("CIDADE_EMPRESA").substring(0, 2)
          ) {
            if (cfop.toString().substring(0, 1) != 5) {
              let cfopDentroEstado = "5" + cfop.substring(1, 4);

              let dadosValidacaoCfop = {
                PROCNAME: "WEBSITE_TCFOP_DESCBYID",
                ID: cfopDentroEstado,
              };
              const retornoValidacaoCfop = await consultaApi(
                dadosValidacaoCfop
              );
              setLoading(false);

              if (retornoValidacaoCfop.data.DATASET) {
                await Swal.fire({
                  title: "CFOP informado incompativel",
                  html: `<p>O CFOP ${cfop} é para vendas para clientes de outro estado.</p>
                    <p>O CFOP ${cfopDentroEstado} seria o equivalente para dentro do estado.</p>
                    <p>Deseja fazer a alteração ?<p/>`,
                  showCancelButton: true,
                  showDenyButton: true,
                  confirmButtonText: `Sim`,
                  cancelButtonText: `Não`,
                }).then((result) => {
                  if (result.value) {
                    setCfop(cfopDentroEstado);
                    return true;
                  } else {
                    setCfopErro(true);
                    setCfopErroTexto(
                      "Por favor preencha o Cfop,campo obrigatorio"
                    );
                    cfopIncorreto = true;
                  }
                });
              } else {
                Swal.fire({
                  type: "error",
                  title: "CFOP invalido para venda dentro do estado.",
                });
                cfopIncorreto = true;
              }
            }
          } else {
            if (cfop.substring(0, 1) != 6) {
              let cfopForaEstado = "6" + cfop.substring(1, 4);

              let dadosValidacaoCfop = {
                PROCNAME: "WEBSITE_TCFOP_DESCBYID",
                ID: cfopForaEstado,
              };
              const retornoValidacaoCfop = await consultaApi(
                dadosValidacaoCfop
              );
              setLoading(false);

              if (retornoValidacaoCfop.data.DATASET) {
                await Swal.fire({
                  title: "CFOP informado incompativel",
                  html: `<p>O CFOP ${cfop} é para vendas para clientes do mesmo estado.</p>
                    <p>O CFOP ${cfopForaEstado} seria o equivalente para fora do estado.</p>
                    <p>Deseja fazer a alteração ?<p/>`,
                  showCancelButton: true,
                  showDenyButton: true,
                  confirmButtonText: `Sim`,
                  cancelButtonText: `Não`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.value) {
                    setCfop(cfopForaEstado);
                    return true;
                  } else {
                    setCfopErro(true);
                    setCfopErroTexto(
                      "Por favor preencha o Cfop,campo obrigatorio"
                    );
                    cfopIncorreto = true;
                  }
                });
              } else {
                Swal.fire({
                  type: "error",
                  title: "CFOP invalido para venda fora do estado.",
                });
                cfopIncorreto = true;
              }
            }
          }
        }
      }
    }

    if (nomeEtapa === "Dados Transporte") {
      if (modeloEntrega !== 0 && modeloEntrega !== 1) {
        if (transportadora === "") {
          setTransportadoraErro(true);
          setTransportadoraErroTexto(
            "Por favor preencha o Transportadora,campo obrigatorio"
          );
          camposErrados.push("Transportadora");
        } else {
          if (descricaoTransportadora === "") {
            setTransportadoraErro(true);
            setTransportadoraErroTexto(
              "Informe um Transportadora valida, use a pesquisa"
            );
            camposErrados.push("Transportadora");
          } else {
            setTransportadoraErro(false);
          }
        }
      }
    }

    if (nomeEtapa === "Parcelas") {
      if (parcelasNota.length !== 0) {
        if (valorTotalNfe !== valorTotalParcelas) {
          Swal.fire({
            type: "error",
            title: `Total das parcelas : ${valorTotalParcelas} \n diverge do total de Produtos : ${valorTotalNfe}`,
          });
          return false;
        }
      }
    }

    if (
      getSteps()[step] !== "Produtos Nota Fiscal" &&
      getSteps()[step] !== "Dados Nota Fiscal"
    ) {
      if (camposErrados.length === 0) {
        if (itensNota.length === 0) {
          Swal.fire({
            type: "error",
            title: "Informe um Produto para continuar o processo.",
          });
          setActiveStep(
            getSteps().findIndex((item) => item == "Produtos Nota Fiscal")
          );
          return false;
        }
      }
    }

    if (cfopIncorreto) {
      setCfopErro(true);
      setCfopErroTexto(
        "Por favor preencher um CFOP compativel com estado do seu cliente."
      );
      return false;
    }

    if (camposErrados.length === 0) {
      return true;
    } else {
      Swal.fire({
        type: "error",
        title: "Campos Inválidos",
        html:
          `<lu>` +
          camposErrados.map((campoErrado) => `<li>${campoErrado}</li>`) +
          `</lu>`,
      });

      return false;
    }
  }

  function apresentarPdf() {
    if (!cancelada && autorizada) {
      return <PdfNfe codigoNfe={codigoNfe} />;
    } 
    return;    
  }

  function sair() {
    history.push("/nfe");
  }

  async function selecionarEtapa(step) {
    setLoading(false);
    // if (!autorizada) {
    if (await validaCampos(step)) {
      setActiveStep(step);
    }
    // }
  }

  return (
    <div className={classes.root}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        className={classes.controlaStepper}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel onClick={() => selecionarEtapa(index)}>
              {label}
            </StepLabel>
            <StepContent>
              <Typography>{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Grid container>
                    {!autorizada && (
                      <Grid item xs={6}>
                        <Button
                          disabled={activeStep === 0}
                          fullWidth
                          onClick={handleBack}
                          className={
                            activeStep == steps.length - 1
                              ? classes.ocultaCampo
                              : classes.button
                          }
                        >
                          Voltar
                        </Button>
                      </Grid>
                    )}
                    <Grid item xs={autorizada ? 12 : 6}>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={handleNext}
                        className={
                          activeStep === steps.length - 1
                            ? classes.ocultaCampo
                            : classes.button
                        }
                      >
                        Próximo
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
